<app-authorized-container *ngIf="userService.isLoggedIn() && isNotChangePassword()"> </app-authorized-container>
<ng-container *ngIf="!userService.isLoggedIn() || !isNotChangePassword()">
<!-- ======= Header ======= -->
<header id="header" class="fixed-top header-transparent" *ngIf="!userService.isLoggedIn()">
    <div class=" d-flex align-items-center justify-content-between">
        <div class="logo">
            <a><img src="../../../assets/images/AsbarLogo.png" alt="" class="img-fluid"></a>
        </div>
        <nav id="navbar" class="navbar">
            <ul>
                <li><a class="nav-link" href="#">{{ 'Footer.ABOUT' | translate }} {{'Tenant.Company_Name' | translate}}</a></li>
                <!-- <li><a class="nav-link" [routerLink]="['/opportunities/opportunity-list']">{{ 'OPPORTUNITIES' | translate }}</a></li> -->
                <li><a class="nav-link" [routerLink]="['/faq/faqs']">{{ 'General.FAQ' | translate }}</a></li>
                <li><a class="nav-link" [routerLink]="['/faq/support-and-help']">{{ 'General.CONTACT_US' | translate }}</a></li>
            </ul>
            <ul>
                <li class="language-dropdown">
                    <select class="language-select" (change)="onLanguageChange($event)" [value]="languageService.currentLanguage">
                        <option value="en">English</option>
                        <option value="ar">العربية</option>
                    </select>
                </li>
                <li><a class="getstarted" [routerLink]="['/authentication/login']">{{ 'General.GET_STARTED' | translate }}</a></li>
            </ul>
            
            <i class="bi bi-list mobile-nav-toggle"></i>
        </nav><!-- .navbar -->
    </div>
</header><!-- End Header -->
<main>
    <router-outlet></router-outlet>
</main>
<app-footer></app-footer>
</ng-container>